var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.loading
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "4",
      "sm": "6"
    }
  }, [_c('statistic-card-horizontal', {
    attrs: {
      "icon": "ShoppingCartIcon",
      "color": "primary",
      "statistic": _vm.cardPenjualan,
      "statistic-title": "Total Penjualan"
    },
    on: {
      "onClick": function onClick($event) {
        return _vm.$router.push('/penjualan');
      }
    }
  })], 1), _c('b-col', {
    attrs: {
      "lg": "4",
      "sm": "6"
    }
  }, [_c('statistic-card-horizontal', {
    attrs: {
      "icon": "BoxIcon",
      "color": "success",
      "statistic": _vm.cardStokBarang,
      "statistic-title": "Stok Barang (Mobil)"
    },
    on: {
      "onClick": function onClick($event) {
        return _vm.$router.push('/kendaraan-barang');
      }
    }
  })], 1), _c('b-col', {
    attrs: {
      "lg": "4",
      "sm": "6"
    }
  }, [_c('statistic-card-horizontal', {
    attrs: {
      "icon": "FileIcon",
      "color": "warning",
      "statistic": _vm.cardCollection,
      "statistic-title": "Collection"
    },
    on: {
      "onClick": function onClick($event) {
        return _vm.$router.push('/collection');
      }
    }
  })], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sales-graphic')], 1), _c('br'), _c('br')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }